module.exports = __webpack_public_path__ + "static/media/student - group.b32bd5cd.png";